import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'medium' | 'large';
  showRank?: number;
}

export default function ComicCard({ comic, size = 'medium', showRank }: ComicCardProps) {
  const coverSizes = {
    small: 'w-[120px] h-[160px]',
    medium: 'w-[160px] h-[213px]',
    large: 'w-[200px] h-[267px]',
  };

  const titleSizes = {
    small: 'text-sm',
    medium: 'text-base',
    large: 'text-lg',
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg">
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 韩漫免费看`}
          className={`${coverSizes[size]} w-full object-cover object-top transition-transform duration-500 group-hover:scale-105`}
          loading="lazy"
        />
        {showRank && (
          <div className="absolute top-2 left-2 w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-white text-sm font-bold">
            {showRank}
          </div>
        )}
        {comic.status === '连载中' && (
          <div className="absolute top-2 right-2 px-2 py-0.5 text-xs font-medium rounded bg-accent-500 text-white whitespace-nowrap">
            {comic.status}
          </div>
        )}
        {comic.status === '已完结' && (
          <div className="absolute top-2 right-2 px-2 py-0.5 text-xs font-medium rounded bg-secondary-500 text-white whitespace-nowrap">
            {comic.status}
          </div>
        )}
        <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-white text-xs whitespace-nowrap">点击查看详情</span>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className={`${titleSizes[size]} font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200`}>
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{comic.author}</p>
        <div className="flex items-center gap-2 mt-1.5">
          <div className="flex items-center gap-0.5">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="text-xs text-foreground-600 font-medium">{comic.rating}</span>
          </div>
          <span className="text-xs text-foreground-400">|</span>
          <span className="text-xs text-foreground-500 whitespace-nowrap">
            {comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views} 阅读
          </span>
        </div>
      </div>
    </Link>
  );
}